///<amd-module name="Core/Medius.Core.Web/Scripts/Medius/core/export/async/pending" />

import * as _ from "underscore";
import * as $ from "jquery";
import * as ko from "knockout";
import * as backendErrorHandler from "Core/Medius.Core.Web/Scripts/Medius/core/backendErrorHandler";
import * as notification from "Core/Medius.Core.Web/Scripts/Medius/core/notification";
import * as globalization from "Core/Medius.Core.Web/Scripts/lib/globalization";
import * as storage from "Core/Medius.Core.Web/Scripts/Medius/lib/store/async";
import * as rest from "Core/Medius.Core.Web/Scripts/Medius/core/communication/json/rest";
import * as path from "Core/Medius.Core.Web/Scripts/Medius/lib/path";
import contextFactory = require("Core/Medius.Core.Web/Scripts/Medius/core/viewmodels/context");
import { getCultureCode } from "../../../lib/utils/user";
import { notifyExportsChange, notifyExportsModalShown, notifyShowNotification } from "Core/Medius.Core.Web/Scripts/Bifrost/communication";
import { isEmbedded } from "Core/Medius.Core.Web/Scripts/appConfig";

const shouldDisplayNotificationsKey = 'should-diplay-async-export-notifications';

class PendingAsyncExports {
    context: any;
    IsPendingExportsModalShown: ko.Observable;
    ShouldDisplayNotifications: ko.Observable;
    toogleNotificationsSubscription: ko.Subscription;
    IsLoading: ko.Computed;
    PendingExports: ko.ObservableArray;
    delayedPendingExportsRequest: any;
    pendingExportsRequest: JQueryPromise<any>;
    deleteExportRequest: JQueryPromise<any>;
    timeouts: any[] = [];
    isInitInProgress: ko.Observable;
    isDeleteInProgress: ko.Observable;
    isDelayedRefreshInProgress: ko.Observable;
    isEmbedded: boolean;

    private messageListener: (event: MessageEvent) => void;

    constructor(){
        const storageInstance = storage.createLocalStore("Core:pending-tasks");

        this.context = contextFactory();

        this.isInitInProgress = ko.observable(false);
        this.isDeleteInProgress = ko.observable(false);
        this.isDelayedRefreshInProgress = ko.observable(false);

        if (!storageInstance.hasItem(shouldDisplayNotificationsKey)) {
            storageInstance.setItem(shouldDisplayNotificationsKey, true);
        }

        this.isEmbedded = isEmbedded();
        this.IsPendingExportsModalShown = ko.observable(false);
        this.ShouldDisplayNotifications = ko.observable(storageInstance.getItem(shouldDisplayNotificationsKey));
        this.toogleNotificationsSubscription = this.ShouldDisplayNotifications.subscribe(() => {
            storageInstance.setItem(shouldDisplayNotificationsKey, this.ShouldDisplayNotifications());
        });

        this.IsLoading = ko.computed(() => {
            return this.isInitInProgress() || this.isDeleteInProgress() || this.isDelayedRefreshInProgress();
        });
        this.PendingExports = ko.observableArray();

        this.messageListener = (event: MessageEvent) => {
            const data = event.data;
            if (!data || data.origin !== 'Bifrost') {
                return;
            }

            switch (data.type) {
                case 'remove-export': {
                    const id = data.data?.id;
                    if (!id) {
                        break;
                    }
                    const pendingExportItem = _(this.PendingExports()).find((p: any) => p?.Id && p.Id() === id);
                    if (pendingExportItem) {
                        this.removePendingExport(pendingExportItem);
                    }
                    break;
                }
                case 'exports-checkbox-clicked': {
                    const isChecked = data.data?.isChecked;
                    if (typeof isChecked !== 'boolean') {
                        break;
                    }
                    if (this.ShouldDisplayNotifications() !== isChecked) {
                        this.ShouldDisplayNotifications(isChecked);
                    }
                    break;
                }
                default:
                    break;
            }
        };

        window.addEventListener('message', this.messageListener);
    }

    showPendingExportsModal() {
        if (this.isEmbedded) {
            notifyExportsModalShown();
            return;
        }
        this.IsPendingExportsModalShown(true);
    }

    scheduleUpdateEvent() {
        const unfinishedExport = _(this.PendingExports()).find((pendingExport) => {
            return pendingExport.TaskState() !== 'Completed' && pendingExport.TaskState() !== 'Failed';
        });

        if (!unfinishedExport) {
            return null;
        }

        const updateInterval = 2000;

        return setTimeout(() => {
            this.refresh();
        }, updateInterval);
    }


    private showExportNotification(type: 'success' | 'error', messageKey: string, messageArgs: any[]) {
        const message = globalization.getFormattedLabelTranslation(messageKey, messageArgs);
        
        if (!this.isEmbedded) {
            type === 'success' ? notification.success(message) : notification.error(message);
        } else {
            notifyShowNotification(type, null, message);
        }
    }

    onExportCompleted(completedExport: any) {
        if (!this.ShouldDisplayNotifications()) {
            return;
        }

        const state = completedExport.TaskState();
        const typeName = completedExport.AsyncTaskTypeName();
        const filesCount = completedExport.ReferencedFilesCount();

        if (state === 'Completed' && typeName === 'CatalogImport' && filesCount === 0) {
            this.showExportNotification(
                'success',
                "#Procurement/catalogManagement/importSuccessMessage",
                [completedExport.TaskStartDateTimeFormatted()]
            );
        }
        else if (state === 'Completed' && typeName === 'CategoryImport' && filesCount === 0) {
            this.showExportNotification(
                'success',
                "#Procurement/categoryManagement/importSuccessMessage",
                [completedExport.TaskStartDateTimeFormatted()]
            );
        }
        else if (state === 'Completed') {
            this.showExportNotification(
                'success',
                "#Core/completedAsyncExportTaskInfo_filename",
                [completedExport.FileName()]
            );
        }
        else if (state === 'Failed') {
            this.showExportNotification(
                'error',
                "#Core/failedAsyncExportTaskInfo_filename",
                [completedExport.FileName()]
            );
        }
    }

    updatePendingExports(updatedPendingExports: any) {
        const newPendingExports: any[] = [];

        _(updatedPendingExports).each((updatedPendingExport) => {
            let existingExport = _(this.PendingExports()).find((pendingExport) => {
                return pendingExport.Id() === updatedPendingExport.Id;
            });

            if (!existingExport) {
                existingExport = this.context.create(updatedPendingExport);
                existingExport.TaskStartDateTimeFormatted = ko.observable(updatedPendingExport.TaskStartDateTime.toLocaleString(getCultureCode()));
            }
            newPendingExports.push(existingExport);

            if (existingExport.TaskState() === 'Failed' || existingExport.TaskState() === 'Completed') {
                return;
            }

            existingExport.TaskState(updatedPendingExport.TaskState);
            existingExport.Progress(updatedPendingExport.Progress);
            existingExport.ErrorMessage(updatedPendingExport.ErrorMessage);
            existingExport.TaskStartDateTime(updatedPendingExport.TaskStartDateTime);
            existingExport.PositionInQueue(updatedPendingExport.PositionInQueue);
            existingExport.ReferencedFilesCount(updatedPendingExport.ReferencedFilesCount);
            if (!existingExport.TaskStartDateTimeFormatted) {
                existingExport.TaskStartDateTimeFormatted = ko.observable(updatedPendingExport.TaskStartDateTime.toLocaleString(getCultureCode()));
            } else {
                existingExport.TaskStartDateTimeFormatted(updatedPendingExport.TaskStartDateTime.toLocaleString(getCultureCode()));
            }

            if (updatedPendingExport.TaskState !== 'InProgress') {
                this.onExportCompleted(existingExport);
                return;
            }
            if (updatedPendingExport.TaskState === 'Queued') {
                return;
            }
        });

        _(this.PendingExports()).each((pendingExport) => {
            const updatedExport = _(updatedPendingExports).find((updatedPendingExport) => {
                return pendingExport.Id() === updatedPendingExport.Id;
            });

            if (!updatedExport) {
                pendingExport.dispose();
            }
        });

        this.PendingExports(_(newPendingExports).sortBy((pendingExport) => {
            return pendingExport.CreatedTimestamp();
        }).reverse());
    }

    clearAllTimeouts() {
        _(this.timeouts).each((timerId) => {
            clearTimeout(timerId);
        });
        this.timeouts = [];
    }

    delayedRefresh() {
        if (this.delayedPendingExportsRequest) {
            return this.delayedPendingExportsRequest;
        }

        this.isDelayedRefreshInProgress(true);
        this.delayedPendingExportsRequest = $.Deferred();
        this.delayedPendingExportsRequest.pipe(() => {
            return this.refresh();
        }).always(() => {
            this.delayedPendingExportsRequest = null;
            this.isDelayedRefreshInProgress(false);
        });

        setTimeout(() => {
            this.delayedPendingExportsRequest.resolve();
        }, 2000);

        return this.delayedPendingExportsRequest;
    }

    wrapAsyncExportTask(asyncExportTaskRequest: any, onExportError?: any) {
        let asyncExportTaskTmp: any;

        return asyncExportTaskRequest.pipe((asyncExportTask: any) => {
            const title = globalization.getLabelTranslation("#Core/asyncExportStartedInfoTitle");
            const message = globalization.getLabelTranslation(
                "#Core/asyncExportStartedInfoMessage_filename",
                asyncExportTask.FileName
            );

            if (!this.isEmbedded) {
                notification.info(message, title);
                this.IsPendingExportsModalShown(true);
            } else {
                notifyShowNotification('info', title, message);
            }

            asyncExportTaskTmp = asyncExportTask;
            notifyExportsModalShown();

            return this.refresh();
        }).pipe(() => {
            this.delayedRefresh();
            return asyncExportTaskTmp;
        }).fail((xhr: any) => {
            const error = backendErrorHandler.formatAnyError(xhr);
            if (onExportError) {
                if (!this.isEmbedded) {
                    onExportError(xhr);
                } else {
                    notifyShowNotification('error', error.title, error.text);
                }
            } else {
                if (!this.isEmbedded) {
                    backendErrorHandler.handleAnyError(xhr);
                } else {
                    notifyShowNotification('error', error.title, error.text);
                }
            }
        });
    }

    refresh() {
        if (this.pendingExportsRequest) {
            return this.pendingExportsRequest;
        }

        this.clearAllTimeouts();

        this.pendingExportsRequest = rest.get("AsyncExportManager", "exports")
            .pipe((pendingExports) => {
                this.updatePendingExports(pendingExports);
                const schedulEventTimer = this.scheduleUpdateEvent();
                if (schedulEventTimer !== null) {
                    this.timeouts.push(schedulEventTimer);
                }
                notifyExportsChange(pendingExports);
                return pendingExports;
            }).fail((xhr) => {
                const error = backendErrorHandler.formatAnyError(xhr);
                if (!this.isEmbedded) {
                    backendErrorHandler.handleAnyError(xhr);
                } else {
                    notifyShowNotification('error', error.title, error.text);
                }
            }).always(() => {
                this.pendingExportsRequest = null;
            });

        return this.pendingExportsRequest;
    }

    init() {
        this.isInitInProgress(true);
        return this.refresh().always(() => {
            this.isInitInProgress(false);
        });
    }

    downloadExportFile(pendingExport: any) {
        const queryString = `?asyncExportTaskId=${pendingExport.Id()}`;
        const url = path.toAction("AsyncExport", "~/AsyncExport") + queryString;
        window.location.href = url;
    }

    onSuccessfulDelete(pendingExport: any) {
        this.PendingExports(_(this.PendingExports()).without(pendingExport));
        pendingExport.dispose();
    }

    removePendingExport(pendingExport: any) {
        if (this.deleteExportRequest) {
            return this.deleteExportRequest;
        }
        this.isDeleteInProgress(true);

        this.deleteExportRequest = $.when(this.pendingExportsRequest).pipe(() => {
            return rest.del(
                "AsyncExportManager", `exports/${pendingExport.Id()}`
            ).pipe(() => {
                this.onSuccessfulDelete(pendingExport);
            }).fail((xhr) => {
                if (xhr.status === 404) {
                    this.onSuccessfulDelete(pendingExport);
                } else {
                    const error = backendErrorHandler.formatAnyError(xhr);
                    if (!this.isEmbedded) {
                        backendErrorHandler.handleAnyError(xhr);
                    } else {
                        notifyShowNotification('error', error.title, error.text);
                    }
                }
            }).always(() => {
                this.deleteExportRequest = null;
                this.isDeleteInProgress(false);
            });
        });

        return this.deleteExportRequest;
    }

    destroy() {
        this.IsLoading.dispose();
        this.PendingExports([]);
        this.toogleNotificationsSubscription.dispose();
        this.context.dispose();

        if (this.messageListener) {
            window.removeEventListener('message', this.messageListener);
        }
    }
}

const pendingAsyncExportsInstance = new PendingAsyncExports();
export = pendingAsyncExportsInstance;